<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div>
		<bread-crumbs
			:title="$t('Communication.Communication')"
			:subTitle="$t('general.SubtitleCommunication')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div v-if="communicationReadPermission" class="vx-row communication-content">
			<div class="vx-col w-full md:w-1/3">
				<vx-card class="communication-content--messages-content">
					<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
						<!-- TODOS LOS RECURSOS CON MENSAJES -->
						<vs-tab :label="$t('Communication.UnresolvedMessages')" icon-pack="feather" icon="icon-inbox">
							<div class="tab-text">
								<vs-row vs-w="12">
									<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
										<!-- Append Two Buttons -->
										<vx-input-group class="mt-2 mb-2">
											<vs-input
												icon-no-border
												:placeholder="$t('Search')"
												v-model="searchQueryRecentTab"
												class="w-full"
											/>

											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														:title="$t('Schedule.Refresh')"
														color="primary"
														icon-pack="feather"
														icon="icon-refresh-cw"
														@click="getResources"
													></vs-button>
												</div>
											</template>
										</vx-input-group>
										<!-- /Append Two Buttons -->
									</vs-col>
								</vs-row>

								<vs-divider class="d-theme-border-grey-light m-0" />
								<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
									<!-- CONTACTS LIST -->
									<div class="chat__contacts">
										<ul class="chat__contacts bordered-items">
											<li
												class="cursor-pointer"
												v-for="resource in resources"
												:key="resource.uid"
												@click="updateActiveChatUser(resource)"
											>
												<communication-resource-item
													:typeOfList="typeOfList"
													:resource="resource"
													@avatarUrlEmit="avatarUrl"
													@cleanListMessages="cleanData"
												></communication-resource-item>
											</li>
										</ul>
									</div>
								</vue-perfect-scrollbar>
							</div>
						</vs-tab>
						<!-- TODOS LOS RECURSOS -->
						<vs-tab :label="$t('Alls')" icon-pack="feather" icon="icon-mail">
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-input
										icon-no-border
										v-model="searchQuery"
										class="g-label w-full"
										icon="icon-search"
										icon-pack="feather"
										:placeholder="$t('Search')"
										@keyup.enter="searchResource"
									/>
								</div>
							</div>
							<div class="vx-row mt-2 mb-2 items-center justify-evenly">
								<div class="vx-col md:w-5/7">
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="
												p-3
												border border-solid
												d-theme-border-grey-light
												rounded-lg
												d-theme-dark-bg
												cursor-pointer
												g-label
											"
										>
											<span style="letter-spacing: 1px"
												>{{ $t(`SearchBy`) }} {{ $t(`${searchField}`) }}</span
											>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu>
											<vs-dropdown-item @click="setSearchField('Name')">
												<span>{{ $t("Name") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('Lastname')">
												<span>{{ $t("Lastname") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('Email')">
												<span>{{ $t("Email") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('Username')">
												<span>{{ $t("Username") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</div>
								<div class="vx-col md:w-1/7 p-0">
									<vx-tooltip :text="$t('Search')">
										<vs-button
											type="filled"
											icon-pack="feather"
											icon="icon-search"
											@click.prevent="searchResource"
										></vs-button>
									</vx-tooltip>
								</div>
								<div class="vx-col md:w-1/7 p-0">
									<vx-tooltip :text="$t('Schedule.Refresh')">
										<vs-button
											color="primary"
											type="filled"
											icon-pack="feather"
											icon="icon-refresh-cw"
											@click.prevent="refresh"
										></vs-button>
									</vx-tooltip>
								</div>
							</div>
							<hr style="border: 0.75px solid #a3a3a3" />
							<div class="vx-row">
								<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
									<!-- CONTACTS LIST -->
									<div class="chat__contacts">
										<ul class="chat__contacts bordered-items">
											<li
												class="cursor-pointer"
												v-for="resource in resourcesDataFilter"
												:key="resource.uid"
												@click="updateActiveChatUser(resource)"
											>
												<communication-resource-item
													:typeOfList="typeOfList"
													:resource="resource"
													@avatarUrlEmit="avatarUrl"
												></communication-resource-item>
											</li>
										</ul>
									</div>
								</vue-perfect-scrollbar>
								<vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-5" />
							</div>
						</vs-tab>
					</vs-tabs>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-2/3">
				<vx-card
					id="communication-content--messages-content"
					class="communication-content--messages-content vs-con-loading__container"
				>
					<div class="vx-row mb-2">
						<div class="vx-col w-full md:w-1/2">
							<span class="g-tools--description">{{ $t("Communication.Messages") }}</span>
						</div>
						<div class="vx-col w-full md:w-1/2 flex justify-end">
							<a href="#" class="g-label--normal text-center">
								<feather-icon class="cursor-pointer g-label--normal" icon="HelpCircleIcon" />
							</a>
						</div>
					</div>
					<hr style="border: 0.75px solid #a3a3a3" />
					<div class="vx-row mt-4 flex items-center">
						<vs-checkbox
							class="ml-10 mr-10"
							:title="$t('SelectAll')"
							:value="checkedAll"
							@change="changeMessage"
						></vs-checkbox>
						<vs-dropdown
							vs-custom-content
							vs-trigger-click
							class="cursor-pointer g-label--normal ml-6"
							:title="$t('Communication.MarkAs')"
						>
							<a class="a-icon g-label--normal" href.prevent>
								<feather-icon class="cursor-pointer g-label--normal" icon="TagIcon" />
								<vs-icon class="" size="medium" icon="expand_more"></vs-icon>
							</a>
							<vs-dropdown-menu class="i18n-dropdown vx-navbar-dropdown" style="min-width: 16rem">
								<vs-dropdown-item
									@click="markAsSeen(true)"
									v-if="validateSelected && communicationUpdatePermission"
								>
									<feather-icon class="cursor-pointer mr-2" icon="EyeIcon" svgClasses="h-5 w-5" />
									&nbsp;{{ $t("Communication.Seen") }}
								</vs-dropdown-item>
								<vs-dropdown-item
									@click="markAsSeen(false)"
									v-if="validateSelected && communicationUpdatePermission"
								>
									<feather-icon class="cursor-pointer mr-2" icon="EyeOffIcon" svgClasses="h-5 w-5" />
									&nbsp;{{ $t("Communication.Unseen") }}
								</vs-dropdown-item>
								<vs-dropdown-item
									@click="markAsState"
									v-if="validateSelected && communicationUpdatePermission"
								>
									<feather-icon class="cursor-pointer mr-2" icon="LockIcon" svgClasses="h-5 w-5" />
									&nbsp;{{ $t("Communication.Resolved") }}
								</vs-dropdown-item>
								<vs-dropdown-item
									@click="markAsStatePennding"
									v-if="validateSelected && communicationUpdatePermission"
								>
									<feather-icon class="cursor-pointer mr-2" icon="UnlockIcon" svgClasses="h-5 w-5" />
									&nbsp;{{ $t("Communication.PendingForResolved") }}
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
						<a
							v-show="validateSelected && communicationDeletePermission"
							href="#"
							class="text-center g-label--normal ml-8"
							:title="$t('Crud.Delete')"
							@click="openConfirmDelete"
						>
							<feather-icon class="cursor-pointer g-label--normal" icon="Trash2Icon" />
						</a>
						<div class="vx-col w-full md:w-3/5 flex justify-end">
							<div class="flex items-center">
								<vs-avatar
									v-if="resourceFullname"
									class="border-2 border-solid border-white"
									:src="resourceAvatar"
									size="42px"
								/>
								<h5 class="g-tools--description">{{ resourceFullname | capitalize }}</h5>
							</div>
						</div>
					</div>
					<div class="vx-row">
						<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
							<!-- MESSAGE LIST -->
							<div class="chat__contacts p-6" v-if="resourceLastMessages.length > 0">
								<ul class="chat__contacts">
									<li
										class="cursor-pointer"
										v-for="message in resourceLastMessages"
										:key="message.key"
									>
										<message-item
											:message="message"
											:isSelected="message.selected"
											@addToSelected="addToSelected"
											@removeSelected="removeSelected"
										></message-item>
									</li>
								</ul>
							</div>
							<div v-if="currentSelectResource !== null && resourceLastMessages.length === 0">
								<communication-empty
									:title="$t('Communication.NoMessages')"
									:text="$t('Communication.NoMessagesText')"
								/>
							</div>
							<communication-empty
								v-if="currentSelectResource === null"
								:title="$t('Communication.Messages')"
								:text="$t('Communication.AlertVisualizarInfo')"
							/>
						</vue-perfect-scrollbar>
					</div>
				</vx-card>
			</div>
		</div>
		<not-permission v-else></not-permission>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NotPermission from "@/views/pages/NotPermission.vue";
import CommunicationResourceItem from "./CommunicationResourceItem.vue";
import MessageItem from "./MessageItem.vue";
import moduleResource from "@/store/resource/moduleResource.js";
import firebase from "firebase/app";
import {updateFirebaseMessage, deleteFireabseMessage} from "@/helpers/firebaseDB.js";
import User from "@/models/User.js";
import CommunicationEmpty from "./CommunicationEmpty.vue";

export default {
	components: {
		CommunicationResourceItem,
		MessageItem,
		VuePerfectScrollbar,
		NotPermission,
		CommunicationEmpty,
	},
	data() {
		return {
			activeItem: "",
			activeAlert: true,
			searchQuery: null,
			searchQueryRecentTab: null,
			database: firebase.database(),
			userSession: new User(),
			currentSelectResource: null,
			active: true,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.7,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			messages: [],
			checkedAll: false,
			searchField: "Name",
			activeTab: 0,
			searchFieldSelected: {value: "Name", label: this.$t("Name")},
			typeOfList: "recent",
			avatar: "",
		};
	},
	watch: {
		currentPage(val) {
			this.getAllResources();
			this.cleanData();
		},
		activeTab(val) {
			this.cleanData();
			if (val === 1) {
				this.typeOfList = "all";
				this.getAllResources();
			} else {
				this.typeOfList = "recent";
				this.getResources();
			}
		},
		searchFieldSelected(val) {
			this.searchField = val.value;
		},
		reloadRecent(val) {
			this.getResources({}, false);
		},
	},
	computed: {
		communicationReadPermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_R");
		},
		communicationCreatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_C");
		},
		communicationUpdatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_U");
		},
		communicationDeletePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_D");
		},
		reloadRecent() {
			return this.$store.getters.getReadMessageNotificationTrigger;
		},
		resourceLastMessages() {
			const compare = (a, b) => {
				if (a.position > b.position) {
					return -1;
				}
				if (a.position < b.position) {
					return 1;
				}
				return 0;
			};
			return this.messages.sort(compare);
		},
		resources() {
			const data = this.$store.state.moduleResource.resourcesComunication;
			if (!this.searchQueryRecentTab || this.searchQueryRecentTab.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return r.name.toLowerCase().includes(this.searchQueryRecentTab.toLowerCase());
			});
		},
		resourcesTabTwo() {
			return this.$store.state.moduleResource.resources;
		},
		resourcesDataFilter() {
			const data = this.resourcesTabTwo;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		resourceFullname() {
			return this.currentSelectResource !== null ? this.currentSelectResource.name : "";
		},
		resourceAvatar() {
			return this.currentSelectResource !== null ? this.avatar : "";
		},
		validateSelected() {
			return this.messages.some((message) => message.selected);
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Email", label: this.$t("Email")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
			];
		},
	},
	methods: {
		avatarUrl(val) {
			this.avatar = val;
		},
		cleanData() {
			this.messages = [];
			this.currentSelectResource = null;
		},
		setSearchField(val) {
			this.searchField = val;
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		handHorder() {
			this.$store.commit("moduleResource/ORDER_DATA");
		},
		getResources(dataPage = {page: null, quantity: null}, activeLoading = true) {
			const usernames = this.$store.getters.getUsernameResources;
			if (usernames.length <= 0) {
				return;
			}
			// ? se agrega los username de los recursos que tienen mensajes activos
			if (this.activeTab === 0) {
				dataPage["username"] = usernames;
			}
			if (activeLoading) this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilterByUsernane", dataPage, {
					component: "communication",
				})
				.then((res) => {
					if (activeLoading) this.closeLoading();
					return res;
				})
				.catch((err) => {
					if (activeLoading) this.closeLoading();
					console.error(err);
				});
		},
		getAllResources(dataPage = {page: this.currentPage, quantity: this.quantityElementPage}) {
			this.$store.commit("moduleResource/CLEAR_RESOURCES");
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", dataPage, {
					component: "communication",
				})
				.then((res) => {
					Object.assign(this.pagination, res.data.pagination);
					this.searchQuery = "";
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		async getMessages(resource) {
			const user = await this.userSession.getUser();
			const starCountRef = this.database.ref(`messages/${user.company_id}/${resource.id}`).orderByChild("date");

			starCountRef.on("value", (snapshot) => {
				this.messages = [];
				snapshot.forEach((childSnapshot) => {
					// key will be "ada" the first time and "alan" the second time
					let key = childSnapshot.key;
					// childData will be the actual contents of the child
					let childData = {
						...childSnapshot.val(),
						key: key,
						resource_id: resource.id,
						selected: false,
					};
					this.messages.push(childData);
				});
			});
		},
		updateActiveChatUser(resource) {
			this.currentSelectResource = resource;
			this.messages = [];
			this.getMessages(resource);
		},
		changeMessage() {
			this.checkedAll = !this.checkedAll;
			this.selectAll(this.checkedAll);
		},
		markAsSeen(val) {
			this.messages
				.filter((message) => message.selected)
				.map((message) => {
					message.seen = val;
					updateFirebaseMessage(message);
					this.checkedAll = false;
					return message;
				});
		},
		markAsState() {
			this.messages
				.filter((message) => message.selected)
				.map((message) => {
					message.state = "Resuelto";
					updateFirebaseMessage(message);
					this.checkedAll = false;
					return message;
				});
		},
		markAsStatePennding() {
			this.messages
				.filter((message) => message.selected)
				.map((message) => {
					message.state = "Pendiente por resolver";
					updateFirebaseMessage(message);
					this.checkedAll = false;
					return message;
				});
		},
		selectAll(val = false) {
			this.messages = this.messages.map((message) => {
				message.selected = val;
				return message;
			});
		},
		deleteMessages() {
			this.messages
				.filter((message) => message.selected)
				.forEach((message) => {
					deleteFireabseMessage(message);
				});
		},
		openConfirmDelete(id) {
			this.dataId = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Communication.DeleteMessages"),
				text: this.$t("Communication.DeleteMessagesText"),
				accept: this.deleteMessages,
			});
		},
		addToSelected(key) {
			const msgIndex = this.messages.findIndex((msj) => msj.key === key);
			this.messages[msgIndex].selected = true;
		},
		removeSelected(key) {
			const msgIndex = this.messages.findIndex((msj) => msj.key === key);
			this.messages[msgIndex].selected = false;
		},
		searchResource() {
			const dataPage = {
				name: this.searchField === "Name" ? this.searchQuery : "",
				lastname: this.searchField === "Lastname" ? this.searchQuery : "",
				username: this.searchField === "Username" ? this.searchQuery : "",
				identification: this.searchField === "Identification" ? this.searchQuery : "",
				email: this.searchField === "Email" ? this.searchQuery : "",
				imei: this.searchField === "Imei" ? this.searchQuery : "",
				order_by: "name",
				sort: "ASC",
			};
			this.getAllResources(dataPage);
		},
		refresh() {
			const dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
			};
			this.getAllResources(dataPage);
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		this.getResources();
	},
	beforeDestroy() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
		this.$store.commit("moduleResource/CLEAR_RESOURCES_COMMUNICATION");
	},
	beforeCreate() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
		this.$store.commit("moduleResource/CLEAR_RESOURCES_COMMUNICATION");
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (from.fullPath === "/" && vm.$store.getters.getUsernameResources.length <= 0) {
				vm.$router.push({name: "dashboard-maps"});
				next();
			}
		});
	},
};
</script>

<style lang="scss" scoped>
.content-message-info {
	margin-top: 8rem;
}

.communication-content {
	height: 650px;
}

.communication-content--messages-content {
	height: 95%;
}

.scroll-area--content-left {
	margin: auto;
	width: 100%;
	max-height: 430px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
